import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import styles from './RPSOneCallRolloverLandingScreen.css';
import Heading from '../../components/Typography/Heading/Heading';
import AlertMessage from '../../components/AlertMessage/AlertMessage';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import { isRPSOCRTraditionalAccount } from '../../flows/front-office/shared/utils';
import { getOCRPageTitle } from '../../flows/front-office/ocr-flows/utils';

export const noRPSPlansFoundText = `No participant match was found based on the SSN entered. Please review.`;
export const updateRPSCustomerSSNFailedText = `The service call failed and you cannot proceed. Please close out the application and try again.`;

const RPSOneCallRolloverLandingScreen = () => {
  const { next, appState } = useContext(FlowContext);
  const {
    store: { accountType, loadedData }
  } = appState;

  const { noRPSPlansFound, updateRPSCustomerSSNFailed } = loadedData;
  const shouldDisableContinueBtn =
    noRPSPlansFound || updateRPSCustomerSSNFailed;

  const isOCRTraditionalAcc = isRPSOCRTraditionalAccount(accountType);

  const accountText = isOCRTraditionalAcc ? 'Traditional' : 'Roth';

  const pageTitle = getOCRPageTitle(accountType);

  return (
    <>
      <div className="ocr-wizard-wrapper">
        {noRPSPlansFound && <AlertMessage message={noRPSPlansFoundText} />}
        {updateRPSCustomerSSNFailed && (
          <AlertMessage message={updateRPSCustomerSSNFailedText} />
        )}
        <Heading text={pageTitle} />
        <div className="ocr-legal-agreement">
          <div className="ocr-new-user-title">New</div>
          You have elected to open a T. Rowe Price {accountText} Rollover IRA.
          We will be walking through the process to establish that Rollover IRA.
          As a follow up to this interaction, you will receive a packet
          containing the T. Rowe Price Traditional and Roth IRA Disclosure
          Statement and Custodial Agreement. Restrictions [will/may] be placed
          on the account until you agree to the terms and conditions by signing,
          dating and returning the form and it is accepted by T. Rowe Price.
          <div className="ocr-existing-user-title">Existing</div>
          You&apos;ve elected to roll assets into an existing {
            accountText
          } or {accountText} Rollover IRA. We will be walking through the
          process to roll over those assets.
        </div>
        <div className="btn-container">
          <MFBeaconButton
            className="continue-button"
            id="rpsRolloverLandingContinueBtn"
            data-name="rpsRolloverLandingContinueBtn"
            variant="primary"
            size="normal"
            onClick={next('landing')}
            disabled={shouldDisableContinueBtn}
            label="Continue"
          />
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default RPSOneCallRolloverLandingScreen;
